(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("RegistrationForm", [], factory);
	else if(typeof exports === 'object')
		exports["RegistrationForm"] = factory();
	else
		root["RegistrationForm"] = factory();
})(this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition